import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Link } from '../../../../../components/Link/Link';
import { firstColumnCategories, fourthColumnCategories, secondColumnCategories, thirdColumnCategories, } from '../../NavigationBar/components/BrowsePostersPanel/constants/categoriesMobile';
import { ImagesLinksList } from './ImagesLinksList';
export const Container = styled.div `
  padding: 25px 0 30px;
`;
export const StyledLink = styled(Link) `
  color: ${({ theme }) => theme.colorsV2.font.textLink};
  font-family: proxima-nova, Corbel, Arial, sans-serif;
  font-size: ${({ theme }) => theme.fontSizes.sizeMd1};
  font-weight: 600;
  line-height: 24px;
  margin-top: 20px;
  text-decoration: none;
`;
export const FindYourDisplatesSubNavigation = () => (_jsxs(Container, { children: [_jsx(ImagesLinksList, { links: firstColumnCategories.links, listTitle: firstColumnCategories.columnTitle }, void 0), _jsx(ImagesLinksList, { links: secondColumnCategories.links, listTitle: secondColumnCategories.columnTitle }, void 0), _jsx(ImagesLinksList, { links: thirdColumnCategories.links, listTitle: thirdColumnCategories.columnTitle }, void 0), _jsx(ImagesLinksList, { links: fourthColumnCategories.links, listTitle: fourthColumnCategories.columnTitle }, void 0), _jsx(StyledLink, Object.assign({ href: "/posters/all" }, { children: "Browse all" }), void 0)] }, void 0));
//# sourceMappingURL=FindYourDisplatesSubNavigation.js.map